<template>

  <div class="vflex">
    <div class="vflex-row-1">

      <div
        style="max-width: 900px"
        class="p-3">
        <job-attach-form
          @created="loadData"
          class="mb-2">
          </job-attach-form>

        <table
          class="table"
          v-if="jobAttachs.length"
          style="margin: 0">
          <thead>
            <tr>
              <th class="text-truncate">{{ $t('Name') }}</th>
              <th class="text-truncate">{{ $t('Author') }}</th>
              <th class="text-truncate">{{ $t('Created at') }}</th>
              <th class="text-truncate"></th>
            </tr>
          </thead>
          <tbody>
            <job-attach-item
              v-for="(attach, index) in jobAttachs"
              :key="index"
              :attach="attach">
              </job-attach-item>
          </tbody>
        </table>

        <no-results
          v-if="!jobAttachs.length">
          {{ $t('There are no items') }}
          </no-results>
      </div>

    </div>
  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import JobAttachForm from './JobAttachForm'
import JobAttachItem from './JobAttachItem'

export default {
  name: 'JobAttach',
  components: {
    ThSort,
    JobAttachForm,
    JobAttachItem
  },
  props: [
  ],
  data () {
    return {
      creating: true,
      loading: true,
      filters: {},
      sort: '-created_at'
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    jobAttachs () {
      return this.$store.getters.getJobAttachs
    },
    paginate () {
      return this.$store.getters.getJobAttachsPaginate
    }
  },
  created () {
    this.loadData(1)
  },
  methods: {
    /*
    filters
    */
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: 1000, // this.$default.limit
        job_id: this.job._id
      }

      this.$store
      .dispatch('selectJobAttachs', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobAttach/JobAttach.vue